import ThematicExpandableRow from './ThematicStatisticTable';
import MessageExpandableRow from './MessageExpandableRow';

const AnalyticsExpandableWrapper = ({ data }) => {
  console.log('Expandable row data:', data);
  return (
    <div>
      <MessageExpandableRow data={data} />
      <hr />
      <ThematicExpandableRow data={data} />
    </div>
  );
};

export default AnalyticsExpandableWrapper;
